import httpClient, { ExtendedAxiosRequestConfig } from '../../../../api/httpClient';
import branchCacheService from './branchCacheService';
import { FilterSortTable } from '../../../../common/components/customdatable/interfaces/DataTable.interface';
import parishService from '../../../../common/services/parishService';
import {
  CreateBranchRequest,
  SelectedBranchRequest,
  BranchResponse,
  BranchRequest,
} from '../models/branches.interface';

async function createBranch(branch: CreateBranchRequest | BranchRequest) {
  const response = await httpClient.post('api/branches/set-branch', branch);

  if (response) {
    branchCacheService.invalidateBranchesCache();
  }

  return response;
}

async function createBranches(branchs: CreateBranchRequest[] | BranchRequest[]) {
  const response = await httpClient.post('api/branches/set-branches', branchs);

  if (response) {
    branchCacheService.invalidateBranchesCache();
  }

  return response;
}

async function getParish(parish: string = '') {
  // Usar el nuevo servicio de parroquias con caché de 24 horas
  return await parishService.getParishList(parish);
}

async function getBranches() {
  // Configuración de caché - solo 30 segundos para mantener datos frescos
  const config: ExtendedAxiosRequestConfig = {
    cache: {
      enabled: true,
      duration: 2 * 1000, // 30 segundos de staleTime
      cacheTime: 2 * 1000, // 1 minuto en caché total
      key: branchCacheService.BRANCHES_CACHE_KEY,
      refetchOnWindowFocus: false,
    },
  };

  // Realizar la solicitud con la configuración de caché
  return await httpClient.get(`api/branches/get-branches`, config);
}

async function clearEmissionPointAssignment(emisionPoint) {
  const response = await httpClient.post(`api/branches/clear-emission-point-assignment`, emisionPoint);

  if (response) {
    branchCacheService.invalidateBranchesCache();
  }

  return response;
}

export default {
  getParish,
  createBranch,
  getBranches,
  createBranches,
  clearEmissionPointAssignment,
};
